import { render } from "./audioPlayer.vue?vue&type=template&id=6af0ec02&scoped=true"
import script from "./audioPlayer.vue?vue&type=script&lang=js"
export * from "./audioPlayer.vue?vue&type=script&lang=js"

import "./audioPlayer.vue?vue&type=style&index=0&id=6af0ec02&lang=scss&scoped=true"
import "./audioPlayer.vue?vue&type=style&index=1&id=6af0ec02&lang=scss"
script.render = render
script.__scopeId = "data-v-6af0ec02"

export default script